const DEFAULT_UPLOAD_PERMISSION_URL = '/orthanc/check-upload-permission';
// const UPLOAD_PERMISSION_URL = 'https://3dqi-ohif-srv.partners.org/orthanc/check-upload-permissio





/**
 * Asks the server whether the current user may upload. Resolves to false when
 * the auth service isn't available yet or the check fails for any reason.
 */
export async function checkUploadPermission(): Promise<boolean> {
  try {
    const userAuthenticationService = (window as any).__ohifUserAuthenticationService;
    if (!userAuthenticationService) {
      console.warn('userAuthenticationService not yet available on window');
      return false;
    }

    const authHeader = userAuthenticationService.serviceImplementation._getAuthorizationHeader();

    const url = (window as any).config?.uploadPermissionUrl ?? DEFAULT_UPLOAD_PERMISSION_URL;
    console.log("Fetching URL for permission check", url);
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        ...authHeader,
      },
    });

    if (!response.ok) {
      throw new Error(`Permission check failed: ${response.status}`);
    }

    const allowed = await response.json();
    return allowed === true || allowed?.allowed === true;
  } catch (err) {
    console.error('Upload permission check failed:', err);
    return false;
  }
}
